export const getPeopleQuantity = (adults: number, kids: number): string => {
  if (kids === 0) return `${adults}`;
  return `${adults} + (${kids} ${kids > 1 ? 'niños' : 'niño'})`;
};
